import styled from '@emotion/styled';
import { bool, node, string } from 'prop-types';
import Messagebar from '../Messagebar';
import Box from '../layouts/Box';

const SidebarContainer = styled.div((props) => ({
  overflow: 'hidden',
  '> *': {
    display: 'flex',
    flexWrap: 'wrap',
    margin: `calc(${props.gap} / 2 * -1)`,
    alignItems: props.stretch ? 'stretch' : 'flex-start',
  },
  '> * > *': {
    margin: `calc(${props.gap} / 2)`,
    flexBasis: props.sideWidth,
    flexGrow: '1',
  },
  '> * > :last-of-type': {
    flexBasis: '0',
    flexGrow: '999',
    zIndex: '1',
  },
}));

const Sidebar = (props) => (
  <SidebarContainer {...props}>
    <Messagebar />
    <div>
      {props.sidebar}
      <Box
        mt={{ mobile: '72px', desktop: '0px' }}
        minWidth={{ mobile: '100%', desktop: `calc(${props.contentWidth} - ${props.gap})` }}
      >
        {props.page}
      </Box>
    </div>
  </SidebarContainer>
);

Sidebar.propTypes = {
  sidebar: node.isRequired,
  page: node.isRequired,
  sideWidth: string,
  contentWidth: string,
  gap: string,
  stretch: bool,
};

Sidebar.defaultProps = {
  sideWidth: null, //ajusts to content width
  contentWidth: '69%', //when to break columns to stack
  gap: '0px', //margin between elements => gap
  stretch: true, //make height even
};

export default Sidebar;
